import { initializeFeatureFlags } from 'owa-feature-flags';

/**
 * Function to initialize feature flags from user boot settings.
 * @param userBootSettingsData The user boot settings data
 */
export const initializeFeatureFlagsFromUserBootSettings = sessionData => {
    const featureOverrides = parseExtraSettings(sessionData?.extraSettings)?.featureOverrides || [];
    const featureFlags = (sessionData.features || []).concat(featureOverrides);
    initializeFeatureFlags(featureFlags);
    return sessionData;
};

function parseExtraSettings(value: string) {
    if (value) {
        try {
            return JSON.parse(value);
        } catch {
            return {};
        }
    }
}
